import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { img, site } from '../data/site';
export function BookingCta() {
  return <section className="relative isolate overflow-hidden border-t border-edge" data-id="element-532" data-mp="2naslwapmwn3">
      <img src={img.foam} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover" data-id="element-533" data-mp="7lcjh3edo094" />
      <div className="absolute inset-0 bg-[linear-gradient(90deg,#08090a_28%,rgba(8,9,10,0.55)_100%)]" aria-hidden="true" data-id="element-534" data-mp="vaov09x6gkel" />

      <div className="relative mx-auto max-w-shell px-5 py-16 sm:px-6 lg:px-10 lg:py-28" data-id="element-535" data-mp="109i65vozrzbl">
        <Reveal className="max-w-xl" data-id="element-536" data-mp="m9yxn1s9qlyr">
          <h2 className="font-display text-3xl font-extrabold leading-[1.05] tracking-tightest text-chalk sm:text-4xl" data-id="element-537" data-mp="qc3ppw32jaja">
            Kies een dienst. Kies een moment. Klaar.
          </h2>
          <p className="mt-4 max-w-md text-[15px] leading-relaxed text-chalk/70" data-id="element-538" data-mp="3733twoa4bsw1">
            Gratis annuleren tot 24 uur voor uw afspraak. U betaalt in de werkplaats, nadat het werk klaar is.
          </p>
          <div className="mt-8 flex flex-wrap gap-3" data-id="element-539" data-mp="15ome4vt78npo">
            <Link to="/book" className="group inline-flex items-center gap-2 rounded-full bg-ember px-6 py-3.5 text-sm font-semibold text-void transition-[background-color,box-shadow] duration-200 ease-smooth hover:bg-white hover:glow" data-id="element-540" data-mp="15q77ii3s20ly">
              Online boeken
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-smooth group-hover:translate-x-0.5" aria-hidden="true" data-id="element-541" data-mp="1tl0ejprox37t" />
            </Link>
            <a href={site.whatsapp} target="_blank" rel="noreferrer" className="rounded-full border border-chalk/20 px-6 py-3.5 text-sm font-medium text-chalk transition-colors duration-200 ease-smooth hover:border-ember hover:text-ember" data-id="element-542" data-mp="23blg9m2nunuy">
              WhatsApp ons
            </a>
          </div>
        </Reveal>
      </div>
    </section>;
}